import * as types from './action-types';
import { Action } from './action';
import { RequiredField } from 'common/types/admin-page.type';

type Loaded<T> = types.Loaded<T & RequiredField>;
type ToggleSelect<T> = types.ToggleSelect<T & RequiredField>;
type SetToEdit<T> = types.SetToEdit<T & RequiredField>;
type SetToDelete<T> = types.SetToDelete<T & RequiredField>;
type SetFilter<T> = types.SetFilter<T & RequiredField>;
type DeleteRows<T> = types.DeleteRows<T & RequiredField>;
type UpdateRow<T> = types.UpdateRow<T & RequiredField>;
type AddRow<T> = types.AddRow<T & RequiredField>;
type SetSort<T> = types.SetSort<T & RequiredField>;

export const loading = (): types.Loading => {
  return { type: Action.LOADING };
};

export const loaded = <T>(payload: Loaded<T>['payload']): Loaded<T> => {
  return { type: Action.LOADED, payload };
};

export const selectAll = (): types.SelectAll => {
  return { type: Action.SELECT_ALL };
};

export const deselectAll = (): types.DeselectAll => {
  return { type: Action.DESELECT_ALL };
};

export const toggleSelect = <T>(payload: ToggleSelect<T>['payload']): ToggleSelect<T> => {
  return { type: Action.TOGGLE_SELECT, payload };
};

export const setToEdit = <T>(payload: SetToEdit<T>['payload']): SetToEdit<T> => {
  return { type: Action.SET_TO_EDIT, payload };
};

export const setToDelete = <T>(payload: SetToDelete<T>['payload']): SetToDelete<T> => {
  return { type: Action.SET_TO_DELETE, payload };
};

export const setFilter = <T>(payload: SetFilter<T>['payload']): SetFilter<T> => {
  return { type: Action.SET_FILTER, payload };
};

export const deleteRows = <T>(payload: DeleteRows<T>['payload']): DeleteRows<T> => {
  return { type: Action.DELETE_ROWS, payload };
};

export const updateRow = <T>(payload: UpdateRow<T>['payload']): UpdateRow<T> => {
  return { type: Action.UPDATE_ROW, payload };
};

export const addRow = <T>(payload: AddRow<T>['payload']): AddRow<T> => {
  return { type: Action.ADD_ROW, payload };
};

export const setSort = <T>(payload: SetSort<T>['payload']): SetSort<T> => {
  return { type: Action.SET_SORT, payload };
};
